import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren } from 'react';

export interface TagProps extends PropsWithChildren {
    color?: string;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: (props: TagProps) => ({
            display: 'flex',
            alignItems: 'center',
            backgroundColor: props.color ?? '#BCB8AE',
            borderRadius: 100,
            padding: '8px 10px'
        }),
        text: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '100%',
            color: '#FFF'
        }
    })
);

export const Tag: FunctionComponent<TagProps> = props => {
    const classes = useStyles(props);

    return (
        <Box className={clsx(classes.container, props.className)}>
            <Typography className={classes.text}>{props.children}</Typography>
        </Box>
    );
};

export default Tag;
